import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";

export class LogisticsVehicleSelectListCtrl implements IController {
  options: any;
  selectedId: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  vehicleTypes: VehicleType[];
  vehicleTypeIds: string[];
  status: LogisticsVehicleStatusType;
  branchIds: string[];
  isStandAlone: boolean;
  onChange: Function;


  private logisticsVehiclesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public excludedMap: any;

  /* @ngInject */
  constructor(private $logisticsVehicle, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.logisticsVehiclesRef = this.$logisticsVehicle();
    if (!this.options) {
      this.loadLimit = 20;
      this.logisticsVehiclesRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.logisticsVehiclesRef, this.loadLimit, {getFullData: true});
    } else {
      this.loadLimit = 0;
      this.infiniteScroll = this.$infiniteScroll(this.logisticsVehiclesRef, this.loadLimit, {ignoreFetch: true});
      this.infiniteScroll.addItems(this.options);
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.logisticsVehiclesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      ids: this.optionIds,
      limit:  this.loadLimit,
      query:  this.queryString,
      isStandAlone: this.isStandAlone,
      vehicleTypes: this.vehicleTypes,
      vehicleTypeIds: this.vehicleTypeIds,
      status: this.status,
      branchIds: this.branchIds,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleSelectList', {
    bindings: {
      options: '<?',
      optionIds: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isStandAlone: '<?',
      vehicleTypes: '<?',
      vehicleTypeIds: '<?',
      status: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./logistics-vehicle-select-list.html').default,
    controller: LogisticsVehicleSelectListCtrl
  });
